var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0358 37.8845H27.461V27.0207H32.349L32.8861 21.6227H27.461V18.8966C27.461 18.5369 27.6038 18.1919 27.8582 17.9376C28.1126 17.6832 28.4575 17.5403 28.8172 17.5403H32.8861V12.1152H28.8172C27.0187 12.1152 25.2938 12.8297 24.022 14.1015C22.7503 15.3732 22.0358 17.0981 22.0358 18.8966V21.6227H19.3232L18.7861 27.0207H22.0358V37.8845Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.62829bcf.svg";
export { ForwardRef as ReactComponent };